export default class CommandeDeclotureController {
	static $inject = [
		'$scope',
		'$stateParams',
		'CommandesService',
		'notification',
		'ModalService',
		'$uibModal',
		'moment',
		'$translate',
		'globalizationManagementService'
	];

	constructor($scope, $stateParams, CommandesService, notification, ModalService, $uibModal, moment, $translate, globalizationManagementService) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.CommandesService = CommandesService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.$translate = $translate;
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
	}

	annuler() {
		this.modalInstance.close();
	}

	async confirmer() {
		try {
			const newDate = this.moment(this.newDateFin, this.dateFormat);
			if (newDate.isValid()) {
				this.modalInstance.close(newDate.format(this.dateFormat));
			}
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}
}